/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PaintbrushThinPlusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABeElEQVR4nO2Uu0oDURCG10K8FCLa2XoBOwu1tbFYcOeywu5MDJIupfgIVpaK+AoqEnwABbEw+BainRYSY2cEJXKycVGTnN1s0ggOnO7s9//zz5x1nP9qFtHGArCeAukRok45/SrXzY8ByQGQviNrvXFITvoCRz9UIHmIwbGAlnoCAwQzwHLeAmatA8kHc245EzgIghEg2UHWWjt40/1hJjiiLiLrXUdwBH8kKox3DWfenATSFyvcHD/MZ3IPpNtJcGC9chxnIJMAsl5a4aRvzDKfCe553qgB2LOXXSdrua47BKS3lmjujYmudhxZzsxQgaWKLPvMMm1ArXCpen64lBrOLHNAWmnj8rghEnVSQ9IL9HUrCIKJ2BjrDZKUrQLGeecoZK9YLA6uFArD7b+N7tnjse66PNvNpRBAklfLKlZ6EkAMVxN+A6Uf3ZrMk17210ySL8vT2npu9le35RSv+9p6OZqJnJnVtWabdga9FP59AZJynPm3+gSuO4A6Az6ukQAAAABJRU5ErkJggg==)
 */
export const PaintbrushThinPlusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="m11.33 14.83-2.16-2.16a1 1 0 0 1-.25-.99l.75-2.57A3 3 0 0 1 11 7.4l8.05-4.91a1.8 1.8 0 0 1 2.47 2.47L16.61 13a3 3 0 0 1-1.72 1.32l-2.57.75a1 1 0 0 1-.99-.25ZM8.74 13.57c-.2-.2-.44-.36-.7-.43a4 4 0 0 0-5 4.42C3.14 18.23 2.68 19 2 19a1 1 0 1 0 0 2h5a4 4 0 0 0 3.86-5.03c-.07-.27-.23-.51-.43-.7l-1.7-1.7ZM19 14a1 1 0 0 1 1 1v3h3a1 1 0 0 1 0 2h-3v3a1 1 0 0 1-2 0v-3h-3a1 1 0 1 1 0-2h3v-3a1 1 0 0 1 1-1Z"
        className={colorClass}
      />
    </svg>
  );
};
